.landing {
  background: #e9f4ee;
}

.header {
  z-index: 1000;
  position: relative;
  max-width: 90rem;
  margin: 0 auto;
  padding: 0 var(--padding);
}

/* ############################################################################
  HERO
############################################################################ */

.hero {
  margin: calc(var(--header-height) * -1) 0 0;
  padding: var(--header-height) 0 0;
  overflow: visible;

  @media (min-width: 769px) {
    overflow: hidden;
  }
}

.heroContent {
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  height: var(--hero-height);
  padding: 4rem 0;
  text-align: center;

  @media (min-width: 769px) {
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    max-width: 81.25rem;
    height: calc(100vh - var(--header-height) - var(--stores-height));
    min-height: 45rem;
    max-height: 60rem;
    margin: 0 auto;
    padding: 4.875rem var(--padding) 3.125rem;
    text-align: left;
  }

  @media (min-width: 1281px) {
    max-width: 90rem;
  }
}

.heroBlur {
  z-index: 100;
  position: absolute;
  top: 3rem;
  width: 100%;
  background: #f2fff8;
  filter: blur(7.5rem);
  aspect-ratio: 1 / 1;

  @media (min-width: 769px) {
    display: none;
  }
}

.heroText {
  display: flex;
  z-index: 500;
  position: relative;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: center;

  @media (min-width: 769px) {
    align-items: flex-start;
    width: 23rem;
  }
}

.heroTitle {
  max-width: 20rem;
  overflow: visible;
  font-size: 3.625rem;
  line-height: 105%;
  font-family: 'Fraunces', var(--font-serif);

  @media (min-width: 769px) {
    font-size: 4rem;
  }
}

.heroHighlight {
  font-family: inherit;
  background: linear-gradient(
    98deg,
    rgb(14, 124, 90) 0%,
    rgb(27, 167, 117) 42%,
    rgb(58, 208, 140) 100%
  );
  background-clip: text;
  background-size: contain;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.heroSubtitle {
  max-width: 21rem;
  margin: 1.75rem auto 2rem;
  padding: 0 1.25rem;
  font-size: 1.25rem;
  line-height: 150%;

  @media (min-width: 400px) {
    max-width: 25rem;
  }

  @media (min-width: 769px) {
    max-width: 23rem;
    padding: 0;
  }
}

.heroInstall {
  height: auto;
}

.heroProductHunt {
  display: block;
  width: 13rem;
  height: 3rem;
  margin: 2.25rem 0 0;
}

.heroBackground {
  display: flex;
  z-index: 400;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  justify-content: center;
  height: 100%;
  overflow: visible;
  user-select: none;

  @media (min-width: 769px) {
    z-index: 100;
    top: 0;
    height: 100%;
  }
}

.heroBackgroundItems {
  position: fixed;
  top: 0;
  width: 100%;
  min-width: 22rem;
  max-width: 24rem;
  height: calc(100vh + var(--hero-height));
  overflow: visible;
  animation-name: heroBackgroundItemsParallaxMobile;
  animation-timing-function: linear;
  animation-fill-mode: both;
  animation-timeline: scroll(root);
  animation-range: entry 0% entry
    calc(100vh + var(--hero-height) + var(--how-it-works-height));

  @media (min-width: 400px) {
    max-width: 33rem;
  }

  @media (min-width: 769px) {
    position: absolute;
    max-width: 100rem;
    height: 100%;
    animation-name: heroBackgroundItemsParallaxDesktop;
    animation-range: entry 0% entry 100vh;
  }
}

.heroBackgroundItem {
  opacity: 0.3625;
  position: absolute;
}

.heroBackgroundItem1,
.heroBackgroundItem2,
.heroBackgroundItem3,
.heroBackgroundItem4,
.heroBackgroundItem5,
.heroBackgroundItem6,
.heroBackgroundItem7,
.heroBackgroundItem8,
.heroBackgroundItem9,
.heroBackgroundItem10 {
  composes: heroBackgroundItem;
}

.heroBackgroundItem2,
.heroBackgroundItem3,
.heroBackgroundItem5,
.heroBackgroundItem6 {
  @media (min-width: 769px) {
    display: none;
  }
}

.heroBackgroundItem7,
.heroBackgroundItem8,
.heroBackgroundItem9,
.heroBackgroundItem10 {
  display: none;

  @media (min-width: 769px) {
    display: block;
  }
}

.heroBackgroundItem1 {
  top: 4.625rem;
  left: -2.75rem;
  width: 10.5rem;
  transform: rotate(24deg);

  @media (min-width: 400px) {
    left: -2.25rem;
    width: 11.75rem;
  }

  @media (min-width: 769px) {
    top: calc(50% - 28.25rem);
    left: 25%;
    width: 10rem;
    transform: rotate(24deg);
  }

  @media (min-width: 1025px) {
    top: calc(50% - 27.25rem);
    left: 23.5%;
  }

  @media (min-width: 1281px) {
    left: 17.75rem;
  }
}

.heroBackgroundItem2 {
  opacity: 0.55;
  top: 26rem;
  left: -9.5rem;
  width: 19rem;
  transform: rotate(-8deg);

  @media (min-width: 400px) {
    top: 26.25rem;
    left: -9.75rem;
    width: 20.5rem;
  }
}

.heroBackgroundItem3 {
  top: 30.5rem;
  right: -9.125rem;
  width: 14.5rem;
  transform: rotate(21deg);

  @media (min-width: 400px) {
    top: 30rem;
    right: -8.125rem;
    width: 14rem;
  }
}

.heroBackgroundItem4 {
  top: 4.5rem;
  right: -7.5rem;
  width: 14.75rem;
  transform: rotate(-17deg);

  @media (min-width: 400px) {
    top: 4.125rem;
    right: -7rem;
    width: 15.75rem;
  }

  @media (min-width: 769px) {
    top: max(8rem, calc(50% - 18rem));
    right: unset;
    left: -7.5rem;
    width: 13.5rem;
    transform: translateY(-50%) rotate(13deg);
    mask-image: radial-gradient(
      100% 245% at 0% 50%,
      black 0%,
      transparent 100%
    );
  }

  @media (min-width: 1025px) {
    top: calc(50% - 12.5rem);
    left: -9rem;
    width: 20rem;
    mask-image: radial-gradient(
      100% 245% at -20% 50%,
      black 0%,
      transparent 100%
    );
  }

  @media (min-width: 1281px) {
    top: calc(50% - 4rem);
    right: unset;
    left: -11rem;
    width: 20rem;
    transform: translateY(-50%) rotate(-8deg);
    mask-image: radial-gradient(
      100% 245% at 0% 50%,
      black 0%,
      transparent 100%
    );
  }

  @media (min-width: 1281px) {
    left: max(-17vw, -17rem);
  }
}

.heroBackgroundItem5 {
  bottom: calc(5.75rem + env(safe-area-inset-bottom) * 1.5);
  left: -7.75rem;
  width: 16rem;
  transform: rotate(-31.82deg);

  @media (min-width: 400px) {
    bottom: calc(5rem + env(safe-area-inset-bottom) * 1.5);
    left: -8rem;
    width: 17rem;
  }
}

.heroBackgroundItem6 {
  right: -3.75rem;
  bottom: calc(7.25rem + env(safe-area-inset-bottom) * 1.5);
  width: 11.5rem;
  transform: rotate(-15.13deg);

  @media (min-width: 400px) {
    right: -4.875rem;
    bottom: calc(6rem + env(safe-area-inset-bottom) * 1.5);
    width: 13.25rem;
  }
}

.heroBackgroundItem7 {
  @media (min-width: 769px) {
    top: 72%;
    left: -4%;
    width: 24rem;
    transform: rotate(-13deg);
  }

  @media (min-width: 1025px) {
    top: 71.25%;
    bottom: unset;
    left: 4rem;
    width: 24.25rem;
  }

  @media (min-width: 1281px) {
    left: 7rem;
  }
}

.heroBackgroundItem8 {
  @media (min-width: 769px) {
    top: calc(50% - 27rem);
    right: 10%;
    width: 16.5rem;
    transform: scaleX(-1);
  }

  @media (min-width: 1025px) {
    right: 19%;
    width: 18rem;
    transform: none;
  }

  @media (min-width: 1281px) {
    right: 21%;
  }
}

.heroBackgroundItem9 {
  @media (min-width: 769px) {
    top: min(83.5%, 48.5rem);
    right: calc(50% - 7.5rem);
    width: 9rem;
    transform: rotate(18deg);
  }

  @media (min-width: 1025px) {
    right: calc(50% - 11.5rem);
  }
}

.heroBackgroundItem10 {
  @media (min-width: 769px) {
    right: -17.5rem;
    bottom: -5.625rem;
    width: 25rem;
    transform: translateX(-50%) rotate(11deg);
  }
}

.heroMedia {
  display: none;

  @media (min-width: 769px) {
    display: flex;
    z-index: 200;
    position: absolute;
    right: 0;
    left: 0;
    justify-content: center;
    align-items: center;
    height: 100%;
    max-height: 36rem;
    margin: 0 0.5rem 0 0;
  }

  @media (min-width: 1025px) {
    margin: 0 2.75rem 0 0;
  }

  @media (min-width: 1281px) {
    position: relative;
    height: auto;
    max-height: unset;
    margin: 0 -1.75rem 0 0;
  }
}

.heroMediaBrowser,
.heroMediaBrowserDarken,
.heroMediaExtension {
  @media (min-width: 769px) {
    display: flex;
    position: absolute;
    top: calc(50% - 0.375rem);
    right: 0;
    left: 0;
    justify-content: flex-end;
    height: 100%;
    transform: translateY(-50%);
  }

  @media (min-width: 1281px) {
    top: unset;
    height: auto;
    transform: none;
  }

  img {
    height: 100%;
    object-fit: cover;
    object-position: 100%;

    @media (min-width: 1281px) {
      object-fit: contain;
    }
  }
}

.heroMediaBrowser,
.heroMediaBrowserDarken {
  @media (min-width: 769px) {
    mask-image: radial-gradient(
      100% 245% at 0% 50%,
      transparent 40%,
      rgba(0, 0, 0, 0.25) 50%,
      black 65%
    );
  }

  @media (min-width: 1281px) {
    mask-image: none;
  }
}

.heroMediaBrowser {
  @media (min-width: 1281px) {
    position: relative;
  }
}

.heroMediaBrowserDarken {
  @media (min-width: 769px) {
    opacity: 0;
    animation: heroMediaBrowserDarkenFadeIn 200ms linear;
    animation-delay: 800ms;
    animation-fill-mode: forwards;
  }
}

.heroMediaExtension {
  @media (min-width: 769px) {
    opacity: 0;
    z-index: 100;
    top: 0;
    animation: heroMediaExtensionFadeIn 550ms var(--bouncy-cubic-bezier);
    animation-delay: 700ms;
    animation-fill-mode: forwards;
    transform: translateY(5%);
  }
}

/* ############################################################################
  STORES
############################################################################ */

.stores {
  display: none;

  @media (min-width: 769px) {
    display: block;
    z-index: 1000;
    position: relative;
    height: var(--stores-height);
    padding: 1.25rem 0;
    background: var(--primary-800);
  }

  img {
    max-height: 2rem;
    margin: 0 1rem;
    object-fit: contain;
  }
}

/* ############################################################################
  HOW IT WORKS
############################################################################ */

.howItWorksTimeline {
  position: relative;
  height: var(--how-it-works-height);

  @media (min-width: 769px) {
    display: none;
  }
}

.howItWorksIOS {
  display: flex;
  position: sticky;
  top: 1.625%;
  flex-direction: column;
  justify-content: center;
  height: 45%;
  min-height: 40rem;
  max-height: 45rem;
  animation-name: howItWorksIOSFadeOut;
  animation-timing-function: linear;
  animation-fill-mode: both;
  view-timeline-name: --how-it-works-timeline;
  animation-timeline: scroll(root);
  animation-range: entry 0% entry
    calc(100vh + var(--hero-height) + var(--how-it-works-height));

  @media (min-width: 769px) {
    display: none;
  }
}

.howItWorksIOSTitle {
  margin: 0 auto 1rem;
  color: var(--neutral-600);
  font-weight: 600;
  font-size: 2.5rem;
  font-family: 'Fraunces', var(--font-serif);
  text-align: center;
}

.howItWorksIOSSubtitle {
  width: 14rem;
  margin: 0 auto;
  color: var(--neutral-500);
  font-size: 1.25rem;
  line-height: 150%;
  text-align: center;
  letter-spacing: -0.01875rem;
}

.howItWorksIOSSteps {
  position: relative;
  left: 50%;
  width: 100%;
  min-width: 20rem;
  max-width: 21rem;
  margin: 2.25rem 0 0;
  border-radius: 0 0 99rem 99rem;
  overflow: hidden;
  translate: -50%;
  aspect-ratio: 0.927;
}

.howItWorksIOSShadow {
  z-index: 50;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  border-radius: 50%;
  content: '';
  background-color: var(--neutral);
  box-shadow: inset 0 0 1rem 0 rgba(0, 0, 0, 0.25);
  aspect-ratio: 1;
}

.howItWorksIOSTopProgress,
.howItWorksIOSBottomProgress {
  z-index: 100;
  position: absolute;
  bottom: -0.4375rem;
  left: -0.4375rem;
  width: calc(100% + 0.8125rem);
  border-radius: 50%;
  animation-fill-mode: both;
  aspect-ratio: 1;
  rotate: 180deg;

  :global(.progress-gradient) {
    width: 100%;
    height: 100%;
  }

  :global(.progress-path) {
    opacity: 0;
    animation: howItWorksProgress linear;
    animation-fill-mode: both;
    stroke: var(--neutral);
    stroke-width: 4.5;
    stroke-dasharray: 100;
    stroke-dashoffset: 100;
    stroke-linecap: round;
    fill: none;
    animation-timeline: --how-it-works-timeline;
    animation-range: entry 100dvh entry
      calc(100dvh + var(--how-it-works-height));
  }
}

.howItWorksIOSTopProgress {
  opacity: 1;
  z-index: 50;

  :global(.progress-gradient) {
    background: conic-gradient(
      from 180deg,
      transparent 12%,
      #3ad08c 12%,
      #0e7c5a 88%,
      transparent 88%
    );
  }
}

.howItWorksIOSBottomProgress {
  z-index: 300;

  :global(.progress-gradient) {
    background: conic-gradient(
      from 180deg,
      transparent 25%,
      #33c284 25%,
      #168b63 75%,
      transparent 75%
    );
  }
}

.howItWorksIOSImage {
  z-index: 50;
  position: absolute;
  transition-timing-function: var(--bouncy-cubic-bezier);
  object-fit: contain;
}

.howItWorksIOSPopover {
  z-index: 50;
  position: absolute;
  left: 50%;
  padding: 0.75rem 1.625rem;
  border-radius: 999rem;
  font-weight: 600;
  font-size: 1.5rem;
  white-space: nowrap;
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 0.25rem 0.25rem 2.25rem -0.5rem rgba(0, 0, 0, 0.25);
  transition-timing-function: var(--bouncy-cubic-bezier);
  backdrop-filter: blur(0.75rem);
}

.howItWorksIOSStep {
  z-index: 100;
  position: absolute;
  left: 50%;
  overflow: hidden;
  translate: -50% 0;
}

.howItWorksIOSStep1,
.howItWorksIOSStep2,
.howItWorksIOSStep3,
.howItWorksIOSStep4,
.howItWorksIOSStep5,
.howItWorksIOSStep6,
.howItWorksIOSStep7,
.howItWorksIOSStep8,
.howItWorksIOSStep9,
.howItWorksIOSStep10,
.howItWorksIOSStep11 {
  composes: howItWorksIOSStep;
}

.howItWorksIOSStep3,
.howItWorksIOSStep4,
.howItWorksIOSStep5,
.howItWorksIOSStep7,
.howItWorksIOSStep8,
.howItWorksIOSStep9,
.howItWorksIOSStep10,
.howItWorksIOSStep11 {
  opacity: 0;
}

.howItWorksIOSStep4,
.howItWorksIOSStep6,
.howItWorksIOSStep8,
.howItWorksIOSStep10,
.howItWorksIOSStep11 {
  z-index: 250;
}

.howItWorksIOSStep1,
.howItWorksIOSStep2,
.howItWorksIOSStep5,
.howItWorksIOSStep6 {
  bottom: 0;
  width: 100%;
  height: 100%;
  border-bottom-right-radius: 999rem;
  border-bottom-left-radius: 999rem;
  background-repeat: no-repeat;
  background-size: contain;
}

.howItWorksIOSStep4,
.howItWorksIOSStep8,
.howItWorksIOSStep10,
.howItWorksIOSStep11 {
  composes: howItWorksIOSImage;
}

.howItWorksIOSStep1,
.howItWorksIOSStep2,
.howItWorksIOSStep5 {
  background-position: center 12rem;
  animation-timing-function: ease-in;
  animation-fill-mode: both;
  animation-timeline: --how-it-works-timeline;
  animation-range: entry 0% entry 100dvh;
}

.howItWorksIOSStep3,
.howItWorksIOSStep7 {
  composes: howItWorksIOSPopover;
}

.howItWorksIOSStep4,
.howItWorksIOSStep8 {
  border: 0.0625rem solid #e2e2e2;
  box-shadow:
    0.25rem 0.5rem 1.5rem -0.375rem rgba(0, 0, 0, 0.2),
    inset 0.125rem 0.125rem 1rem rgba(167, 167, 167, 0.25);
}

.howItWorksIOSStep1 {
  background-image: url('/images/landing/how-it-works/ios/step-1.avif');
  animation-name: howItWorksIOSStep1;
}

.howItWorksIOSStep2 {
  z-index: -1;
  background-image: url('/images/landing/how-it-works/ios/browser-tab.avif');
  animation-name: howItWorksIOSStep2;
}

.howItWorksIOSStep3 {
  z-index: 150;
  bottom: 33.3%;
  translate: -50% 4rem;
}

.howItWorksIOSStep4 {
  bottom: 17.33%;
  left: 49.5%;
  width: 22.5%;
  border-radius: 25%;
  aspect-ratio: 1;
  translate: -50% 50%;
  scale: 0.525;
}

.howItWorksIOSStep5 {
  z-index: 100;
  background-image: url('/images/landing/how-it-works/ios/step-3.avif');
  animation-name: howItWorksIOSStep3;
}

.howItWorksIOSStep6 {
  background-image: url('/images/landing/how-it-works/ios/share-panel.avif');
  background-position: center 14rem;
}

.howItWorksIOSStep7 {
  z-index: 200;
  bottom: 66.33%;
  translate: -50% 4rem;
}

.howItWorksIOSStep8 {
  bottom: 19.5%;
  left: calc(50% + 1.0625rem);
  width: 33.33%;
  border-color: #d9d9d9;
  border-radius: 25%;
  aspect-ratio: 1;
  scale: 0.65;
  translate: -50% 0;
}

.howItWorksIOSStep9 {
  height: 100%;
  background: radial-gradient(
    80% 45% at center center,
    var(--neutral) 1.25rem,
    transparent
  );
  aspect-ratio: 0.74;
}

.howItWorksIOSStep10 {
  bottom: 13.5%;
  left: 50%;
  width: 89%;
  scale: 0.8;
  translate: -50% 10rem;
}

.howItWorksIOSStep11 {
  bottom: 60%;
  left: 50%;
  width: 25%;
  translate: -50% 50%;
  scale: 0.5;
}

/* ############################################################################
  FEATURES
############################################################################ */

.features {
  z-index: 600;
  position: relative;
  padding: 2rem var(--padding);
  border-top: 0.125rem solid rgba(255, 255, 255, 0.8);
  border-radius: 1.875rem 1.875rem 0 0;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.5) 0%,
    rgba(255, 255, 255, 0) 35%
  );
  backdrop-filter: blur(1rem);

  @media (min-width: 769px) {
    padding: 0;
    border: none;
    background: transparent;
    backdrop-filter: none;
  }

  @media (min-width: 1025px) {
    margin: 1rem 0 0;
  }

  @media (min-width: 1281px) {
    margin: 2.5rem 0 0;
  }
}

.featuresBackground {
  z-index: 20;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;

  @media (min-width: 769px) {
    display: none;
  }
}

.featuresBackgroundBlob {
  position: absolute;
  border-radius: 99rem;
  aspect-ratio: 1 / 1;
}

.featuresBackgroundBlob1,
.featuresBackgroundblob2,
.featuresBackgroundBlob3,
.featuresBackgroundBlob4,
.featuresBackgroundBlob5,
.featuresBackgroundBlob6 {
  composes: featuresBackgroundBlob;
}

.featuresBackgroundBlob1 {
  opacity: 0.3;
  top: 2.5rem;
  right: -13rem;
  width: 22rem;
  background: #9ce8dc;
  filter: blur(3.75rem);
}

.featuresBackgroundBlob2 {
  opacity: 0.3;
  top: 11rem;
  left: -9rem;
  width: 20.75rem;
  background: #8ee7b8;
  filter: blur(6.25rem);
}

.featuresBackgroundBlob3 {
  opacity: 0.27;
  top: 37rem;
  right: -12rem;
  width: 17.625rem;
  background: #9dfaf8;
  filter: blur(3.625rem);
}

.featuresBackgroundBlob4 {
  opacity: 0.33;
  top: 49rem;
  left: -10rem;
  width: 19.375rem;
  background: #a3e9bb;
  filter: blur(5.125rem);
}

.featuresBackgroundBlob5 {
  opacity: 0.3;
  top: 79.5rem;
  left: -9rem;
  width: 23.3125rem;
  background: #97efb4;
  filter: blur(3.375rem);
}

.featuresBackgroundBlob6 {
  opacity: 0.3;
  top: 81.5rem;
  right: -12rem;
  width: 22rem;
  background: #54d5df;
  filter: blur(4.25rem);
}

.feature {
  display: flex;
  z-index: 50;
  position: relative;
  justify-content: center;
  margin: 0 auto 4rem;

  @media (min-width: 769px) {
    margin: 0 0 -5rem;
    padding: 4rem var(--padding) 14rem;
    overflow: hidden;
  }
}

.featureContent,
.featureBackground {
  @media (min-width: 769px) {
    max-width: 70rem;
  }
}

.featureBackground {
  position: absolute;

  @media (min-width: 769px) {
    width: calc(100% - var(--padding) * 2);
  }
}

.featureBackgroundImage {
  display: none;
  position: absolute;

  @media (min-width: 769px) {
    display: block;
  }
}

.featureBackgroundImage1,
.featureBackgroundImage2,
.featureBackgroundImage3 {
  composes: featureBackgroundImage;
}

.featureBackgroundPrice {
  display: none;

  @media (min-width: 769px) {
    display: block;
    position: absolute;
    padding: 0.75rem 1.25rem;
    border: 1px solid var(--neutral-200);
    border-radius: 99rem;
    background: #ffffff;
    box-shadow:
      0 0.25rem 1.25rem -0.75rem rgba(0, 0, 0, 0.25),
      inset 0.0625rem -0.25rem 1rem -0.375rem rgba(0, 0, 0, 0.15);
  }
}

.featureBackgroundPrice1,
.featureBackgroundPrice2,
.featureBackgroundPrice3,
.featureBackgroundPrice4,
.featureBackgroundPrice5 {
  composes: featureBackgroundPrice;
}

.featureBackgroundPriceText {
  font-size: 1.5rem;
  background: linear-gradient(85.25deg, #8fe792 -49.1%, #56a1a7 131.88%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-fill-color: transparent;
}

.featureContent {
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (min-width: 769px) {
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
}

.featureText {
  flex: 0 0 auto;
}

.featureSub {
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 140%;
  font-family: var(--font-sans);
  letter-spacing: 0.05em;

  @media (min-width: 400px) {
    font-size: 1rem;
  }
}

.featureTitle {
  margin: 0.5rem 0 0.5rem;
  font-weight: 600;
  font-size: 3rem;
  font-family: 'Fraunces', var(--font-serif);
  text-align: left;

  @media (min-width: 400px) {
    font-size: 3.375rem;
  }
}

.featureDescription {
  max-width: 16.25rem;
  font-size: 1.125rem;
  line-height: 150%;

  @media (min-width: 400px) {
    max-width: 18.5rem;
    font-size: 1.25rem;
  }
}

.featureWishlists,
.featureFriends,
.featurePriceDrops {
  composes: feature;
}

.featureWishlists,
.featureFriends {
  .featureBody {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 0 2rem;
    overflow: auto;
    scrollbar-width: none;

    @media (min-width: 769px) {
      padding: 0;
    }
  }
}

/* ############################################################################
  FEATURES - WISHLISTS
############################################################################ */

.featureWishlists {
  @media (min-width: 769px) {
    padding: 4rem var(--padding) 7rem;
  }

  .featureContent {
    @media (min-width: 769px) {
      display: flex;
      z-index: 20;
      position: relative;
      margin: 0 0 1rem;
      padding: 2.75rem 2.5rem 3rem;
      border-radius: 2rem;
      background: white;
      box-shadow:
        0 0.0625rem 0.125rem rgba(12, 31, 22, 0.05),
        0 1rem 2rem -1.5rem rgba(12, 31, 22, 0.2);
    }
  }

  .featureBackground {
    @media (min-width: 769px) {
      top: 0;
    }
  }

  .featureBackgroundImage1 {
    z-index: 500;
    top: 8.375rem;
    right: -11rem;
    width: 24rem;
  }

  .featureBackgroundImage2 {
    opacity: 0.5;
    top: 2.5625rem;
    left: -12rem;
    width: 21.375rem;
    transform: rotate(-5deg);
  }

  .featureText {
    @media (min-width: 769px) {
      padding: 0 3.25rem 0 0;
    }
  }

  .featureBody {
    margin: 2rem calc(var(--padding) * -1) 0;
    overflow: hidden;

    @media (min-width: 769px) {
      margin: 0 -1.5rem;
      mask-image: linear-gradient(
        to right,
        transparent,
        black 20%,
        black 80%,
        transparent
      );
    }

    .marquee {
      margin: 0 0 -0.5rem;
      padding: 1rem 0;

      &:last-child {
        margin: -0.5rem 0 0 -4rem;
      }
    }
  }
}

/* ############################################################################
  FEATURES - FRIENDS
############################################################################ */

.featureFriends {
  .featureContent {
    @media (min-width: 769px) {
      flex-direction: row-reverse;
    }

    @media (min-width: 1025px) {
      padding: 0 0 0 6.5rem;
    }
  }

  .featureText {
    @media (min-width: 769px) {
      max-width: 20.5rem;
      padding: 0 0 0 3.25rem;
    }
  }

  .featureBackgroundImage1 {
    z-index: 500;
    top: -1.625rem;
    left: -12rem;
    width: 21.875rem;
    mask-image: radial-gradient(
      150% 85% at 55% 20%,
      rgba(0, 0, 0, 1) 51.84%,
      rgba(0, 0, 0, 1) 74.88%,
      rgba(0, 0, 0, 0) 100%
    );

    @media (min-width: 1025px) {
      top: -3.25rem;
      left: -8rem;
      width: 24rem;
    }
  }

  .featureBackgroundImage2 {
    opacity: 0.5;
    top: 12.3125rem;
    right: -9rem;
    width: 18rem;
    transform: rotate(9deg);

    @media (min-width: 1025px) {
      top: 12.75rem;
    }

    @media (min-width: 1281px) {
      top: 13.5rem;
    }
  }

  .featureBody {
    margin: 1rem calc(var(--padding) * -1) 0;

    @media (min-width: 769px) {
      margin: 0;
      mask-image: linear-gradient(
        to right,
        transparent,
        black 20%,
        black 80%,
        transparent
      );
    }

    .marquee {
      margin: 0 0 -0.5rem;
      padding: 2rem 1rem 1rem;

      &:last-child {
        margin: -0.5rem 0 0 -4rem;
      }
    }
  }
}

/* ############################################################################
  FEATURES - PRICE DROPS
############################################################################ */

.featurePriceDrops {
  @media (min-width: 769px) {
    padding: 4rem var(--padding) 17rem;
  }

  .featureBackgroundImage1 {
    @media (min-width: 769px) {
      display: block;
      opacity: 0.5;
      position: absolute;
      top: -5.5rem;
      left: 9.25rem;
      width: 11rem;
      transform: rotate(-15deg);
    }

    @media (min-width: 1025px) {
      left: 10.5rem;
    }
  }

  .featureBackgroundImage2 {
    @media (min-width: 769px) {
      display: block;
      opacity: 0.5;
      position: absolute;
      top: 19.25rem;
      left: 6.5%;
      width: 16rem;
      transform: rotate(-9.29deg);
    }

    @media (min-width: 1025px) {
      top: 20rem;
      left: 4.125rem;
    }
  }

  .featureBackgroundImage3 {
    @media (min-width: 769px) {
      display: block;
      opacity: 0.5;
      position: absolute;
      top: 20.125rem;
      left: calc(50% + 2.5rem);
      width: 18.25rem;
      mask-image: linear-gradient(to top, black 75%, transparent);
    }

    @media (min-width: 1025px) {
      left: calc(50% + 4.125rem);
      width: 18.75rem;
    }
  }

  .featureBackgroundPrice1 {
    top: -0.875rem;
    left: -5rem;
    transform: rotate(-5deg);
  }

  .featureBackgroundPrice2 {
    top: 23rem;
    left: -3.25rem;
    transform: rotate(7.33deg);
  }

  .featureBackgroundPrice3 {
    z-index: 50;
    top: 29.5rem;
    left: calc(50% - 14.75rem);
    transform: rotate(-4.88deg);
  }

  .featureBackgroundPrice4 {
    top: 25rem;
    right: calc(50% - 3.25rem);
    transform: rotate(7.8deg);
  }

  .featureBackgroundPrice5 {
    top: 27rem;
    right: calc(50% - 27.125rem);
    transform: rotate(-4.19deg);

    @media (min-width: 1025px) {
      right: calc(50% - 30.75rem);
    }
  }

  .featureText {
    @media (min-width: 769px) {
      padding: 0 3.75rem 0 0;
    }
  }

  .featureBody {
    display: flex;
    position: relative;
    justify-content: center;
    width: 100%;
    margin: 2rem 0 0;
    overflow: hidden;
    view-timeline-name: --feature-price-drops-phone;
    mask-image: radial-gradient(285% 40% at 50% 100%, transparent 25%, black);

    @media (min-width: 769px) {
      margin: 0;
      mask-image: radial-gradient(190% 65% at 50% 100%, transparent 25%, black);
    }
  }
}

.featurePriceDropsBlur {
  display: none;
  z-index: -1;
  position: absolute;
  top: 0;
  width: calc(100% - var(--padding) * 2);
  max-width: 100rem;
  height: 100%;
  background: radial-gradient(50% 50% at 50% 50%, #ffffff, transparent);

  @media (min-width: 769px) {
    display: block;
  }
}

.featurePriceDropsPhone {
  z-index: 20;
  width: 100%;
  max-width: 22rem;
  animation-name: featurePriceDropsIPhone;
  animation-timing-function: ease-in;
  animation-fill-mode: both;
  transform: translateY(3.25rem);
  object-fit: cover;
  object-position: center top;
  aspect-ratio: 1 / 1.05;
  animation-timeline: --feature-price-drops-phone;
  animation-range: entry 0%;

  @media (min-width: 769px) {
    margin: 0 0 -3rem;
    aspect-ratio: 1 / 1.25;
  }
}

.featurePriceDropsPhone1,
.featurePriceDropsPhone2,
.featurePriceDropsPhone3 {
  composes: featurePriceDropsPhone;
}

.featurePriceDropsPhone2,
.featurePriceDropsPhone3 {
  display: none;

  @media (min-width: 769px) {
    display: block;
    opacity: 0.8;
    z-index: 10;
    position: absolute;
  }
}

.featurePriceDropsPhone2 {
  opacity: 0.8;
  bottom: -2rem;
  left: 0.5rem;
  rotate: -2deg;
}

.featurePriceDropsPhone3 {
  opacity: 0.8;
  right: 0.5rem;
  bottom: -2rem;
  rotate: 4deg;
  translate: 0 0;
}

.featurePriceDropsAnimation {
  z-index: 50;
  position: absolute;
  top: 4rem;
  width: calc(100% - 3rem);
  max-width: 19rem;
  animation-name: featurePriceDropsIPhone;
  animation-timing-function: ease-in;
  animation-fill-mode: both;
  transform: translateY(3.25rem);
  animation-timeline: --feature-price-drops-phone;
  animation-range: entry 0%;
}

.priceDrop {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  border-radius: 1.25rem;
  font-family: 'Helvetica', var(--font-sans);
  background: rgba(255, 255, 255, 0.85);
  box-shadow: 0 0.875rem 1.5rem 0 rgba(0, 0, 0, 0.375);
  gap: 0.375rem;
  backdrop-filter: blur(0.5rem);
}

.priceDropHead,
.priceDropBody {
  display: flex;
  align-items: center;
  width: 100%;
}

.priceDropHead {
  margin: 0 0 0.1875rem;
}

.priceDropHeadLogo {
  width: 1.375rem;
  height: 1.375rem;
  margin: -0.125rem 0.5rem 0 0;
}

.priceDropHeadTimestamp {
  margin: 0 0 0 auto;
}

.priceDropBodyText {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  row-gap: 0.25rem;
}

.priceDropBodyImage {
  width: 4.75rem;
  height: 3rem;
  margin: 0 0 0 1rem;
  object-fit: cover;
}

.priceDrop1 {
  composes: priceDrop;
}

.priceDrop1 {
  opacity: 0;
  transform: translateY(-3.25rem) scale(0.975);
}

/* ############################################################################
  REVIEWS
############################################################################ */

.reviews {
  z-index: 1000;
  position: relative;
  margin: -2.5rem auto 0;
  padding: 4rem 1.5rem 7rem;
  overflow: hidden;

  @media (min-width: 769px) {
    width: calc(100% - 3.5rem);
    max-width: 1200px;
    margin: -1.25rem auto 4.25rem;
  }
}

.reviewsBackground {
  position: absolute;
  top: 0;
  left: 50%;
  width: 500%;
  height: 100%;
  border-radius: 50%;
  background:
    radial-gradient(
      150% 80% at 78% 6%,
      rgba(255, 255, 255, 0.1) 0%,
      rgba(255, 255, 255, 0) 50%
    ),
    linear-gradient(165deg, #1f6149 0%, #143f2b 60%, #0c1f16 100%);
  transform: translateX(-50%);

  @media (min-width: 769px) {
    width: 100%;
    border-radius: 2rem;
  }
}

.reviewsBody {
  z-index: 50;
  position: relative;
  text-align: center;
}

.reviewsTitle {
  max-width: 15rem;
  margin: 0 auto 2.75rem;
  font-size: 2.75rem;
  line-height: 130%;
  font-family: 'Fraunces', var(--font-serif);
}

.reviewsSlider {
  margin: 1.875rem -1.5rem 0;
}

.review {
  max-width: 21.5rem;
  margin: 0 var(--padding);
  text-align: left;

  @media (min-width: 601px) {
    margin: 0 1.25rem;
  }
}

.reviewsInstall {
  @media (min-width: 769px) {
    display: none;
  }
}

.reviewsInstallTitle {
  margin: 3.375rem 0 0;
  font-size: 2.875rem;
  font-family: 'Fraunces', var(--font-serif);
  text-align: center;
}

.reviewsInstallHighlight {
  font-family: 'Fraunces', var(--font-serif);
  background: linear-gradient(
    98deg,
    rgb(143, 233, 192) 0%,
    rgb(199, 246, 223) 100%
  );
  background-clip: text;
  background-size: contain;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.reviewsInstallSubtitle {
  display: block;
  margin: 0.875rem 0 1.875rem;
  color: rgba(255, 255, 255, 0.72);
  font-size: 1.25rem;
}

/* ############################################################################
  CALL TO ACTION
############################################################################ */

.cta {
  display: none;

  @media (min-width: 769px) {
    display: block;
    margin: 0 0 4.5rem;
  }
}

.ctaTitle {
  font-size: 2.875rem;
  font-family: 'Fraunces', var(--font-serif);
  text-align: center;
}

.ctaHighlight {
  font-family: inherit;
  background: linear-gradient(
    98deg,
    rgb(14, 124, 90) 0%,
    rgb(30, 156, 112) 42%,
    rgb(46, 168, 113) 100%
  );
  background-clip: text;
  background-size: contain;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.ctaSubtitle {
  display: block;
  margin: 0.875rem 0 1.875rem;
  font-size: 1.25rem;
  text-align: center;
}

.ctaButton {
}

/* ############################################################################
  FOOTER
############################################################################ */

.footer {
  z-index: 1000;
  position: relative;
  margin: -2.5rem auto 0;
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
  overflow: hidden;

  @media (min-width: 769px) {
    max-width: 75rem;
    margin: 0 auto;
  }
}

@keyframes heroMediaBrowserDarkenFadeIn {
  100% {
    opacity: 1;
  }
}

@keyframes heroMediaExtensionFadeIn {
  100% {
    opacity: 1;
    transform: none;
  }
}

@keyframes heroBackgroundItemsParallaxMobile {
  0% {
    opacity: 0.85;
    transform: none;
  }

  33%,
  75% {
    opacity: 0.85;
    transform: translateY(-35rem) scale(1.05);
  }

  96%,
  100% {
    opacity: 0;
    transform: translateY(-35rem) scale(1.15);
  }
}

@keyframes heroBackgroundItemsParallaxDesktop {
  0% {
    transform: none;
  }

  100% {
    transform: translateY(33%);
  }
}

@keyframes howItWorksIOSFadeOut {
  0%,
  70% {
    opacity: 1;
    transform: none;
  }

  75% {
    transform: none;
  }

  96%,
  100% {
    opacity: 0;
    transform: scale(0.9);
  }
}

@keyframes howItWorksProgress {
  0% {
    stroke-dashoffset: 87.5;
  }

  0.1%,
  100% {
    opacity: 1;
  }

  100% {
    stroke-dashoffset: 12.5;
  }
}

@keyframes howItWorksIOSStep1 {
  100% {
    background-position: center 0;
  }
}

@keyframes howItWorksIOSStep2 {
  99.99% {
    z-index: -1;
  }

  100% {
    z-index: 200;
    background-position: center 0;
  }
}

@keyframes howItWorksIOSStep3 {
  100% {
    background-position: center 0;
  }
}

@keyframes featurePriceDropsIPhone {
  100% {
    transform: none;
  }
}
